import { Link, useLocation } from "@tanstack/react-router";
import {
  Activity,
  ArrowRight,
  Search,
  Sparkles,
  TrendingUp,
} from "lucide-react";
import { toModePath } from "@/app/mode/config";
import { cn } from "@/shared/lib/utils";

const ACTIONS = [
  {
    label: "키워드 분석",
    desc: "수익성 높은 키워드 발굴",
    to: "/keywords/analysis",
    icon: <Search className="size-4" />,
    color: "bg-accent/10 text-text-brand",
  },
  {
    label: "콘텐츠 작성",
    desc: "SEO 최적화 블로그 초안",
    to: "/contents/workspace/write-post",
    icon: <Sparkles className="size-4" />,
    color: "bg-pink-500/10 text-pink-600",
  },
  {
    label: "채널 진단",
    desc: "AI 건강도 분석 리포트",
    to: "/channels/diagnostics/health",
    icon: <Activity className="size-4" />,
    color: "bg-violet-500/10 text-violet-600",
  },
  {
    label: "순위 추적",
    desc: "실시간 키워드 순위 모니터",
    to: "/keywords/tracking",
    icon: <TrendingUp className="size-4" />,
    color: "bg-emerald-500/10 text-emerald-600",
  },
];

export function QuickActions() {
  const location = useLocation();

  return (
    <div className="mb-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {ACTIONS.map((action) => (
        <Link
          key={action.to}
          to={toModePath(action.to, location.pathname)}
          className="group flex items-center gap-3 rounded-sm border border-stroke-subtle bg-surface-raised p-3.5 transition-all hover:border-accent/30 hover:shadow-none"
        >
          <div
            className={cn(
              "flex size-9 shrink-0 items-center justify-center rounded-sm",
              action.color,
            )}
          >
            {action.icon}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[13px] font-semibold group-hover:text-text-brand">
              {action.label}
            </p>
            <p className="text-[11px] text-text-tertiary">{action.desc}</p>
          </div>
          <ArrowRight className="size-3.5 shrink-0 text-text-tertiary/50 transition-transform group-hover:translate-x-0.5 group-hover:text-text-brand" />
        </Link>
      ))}
    </div>
  );
}
